// extracted by mini-css-extract-plugin
export default {"root":"Content_root__eZSYs","container":"Content_container__csnzu"};